var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manually-upload"},[_c('div',{staticStyle:{"width":"500px"}},[_c('file-upload',{ref:"fileUploadHook",attrs:{"isNeedAuthpority":"","resetFlag":_vm.visible,"downloadTplTip":"下载导入模板","autoUploadConfirmTxt":"确定导入","uploadFileUrl":_vm.uploadFileUrl,"title":'',"uploadData":_vm.uploadData,"fileTypeLimit":"xlsx","accept":".xlsx","httpRequest":_vm.httpRequest},on:{"success":_vm.importSuccess,"download-err-excel":_vm.downloadTpl,"download-tpl":_vm.downloadTpl,"cancel":()=>{
        this.$refs.fileUploadHook.reset();
        _vm.$emit('cancel');
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }